import React, { Suspense } from 'react';

const DelayedSmartPageEditorStep =
  React.lazy(() => import(/* webpackChunkName: "smart-page-editor-step.async" */ './smart-page-editor-step')
    .then(({ SmartPageEditorStepWithI18n }) => ({ default: SmartPageEditorStepWithI18n })));

export const DelayedSmartPageEditorStepWithI18n = () => (
  <Suspense fallback={null}>
    <DelayedSmartPageEditorStep />
  </Suspense>
);
